import React, { FC, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Roles.module.scss';
import { Tag, DropdownContainer, ClickDetector } from 'esa-ui-library';
import { PropertyType } from '../../../../../common';
import { Role } from '../../../../components';
import { v4 as uuid } from 'uuid';

interface RolesProps {
	roles: PropertyType[];
}

const Roles: FC<RolesProps> = ({ roles }) => {
	const [moreOpened, setMoreOpened] = useState(false);

	const onMoreChange = () => {
		setMoreOpened((prev) => !prev);
	};

	const renderMoreRoles = () => {
		const updateRoles = [...roles];
		updateRoles.shift();

		return updateRoles?.map((r: PropertyType) => (
			<Role key={uuid()} name={r.name} color={r.color} className={styles.MoreRole} />
		));
	};

	return (
		<section className={styles.Roles} data-testid='roles'>
			{!!roles.length && (
				<>
					<Role name={roles[0].name} color={roles[0].color} />
					{roles.length > 1 && (
						<ClickDetector onOutsideClick={() => setMoreOpened(false)} dataId='detector'>
							<div onClick={onMoreChange} data-testid='more-roles'>
								<Tag text={`+${roles.length - 1}`} className={styles.MoreRoles} />
								{moreOpened && (
									<DropdownContainer>
										<>{renderMoreRoles()}</>
									</DropdownContainer>
								)}
							</div>
						</ClickDetector>
					)}
				</>
			)}
		</section>
	);
};

Roles.propTypes = {
	roles: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};

export { Roles };
